import { UseQueryResult, useQuery } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { CompanyData, CompanyResponse } from "../types/companies.type";

export const useCompany: (id: string) => UseQueryResult<CompanyData, unknown> = (id) => {
  const privateAxios = usePrivateAxios();
  return useQuery<CompanyResponse, unknown, CompanyData>({
    queryKey: ['company', id],
    queryFn: () => privateAxios.get(`/client/companies/${id}`),
    select: (data) => {
      return data?.data?.data
    }
  })
}